<template>
	<section v-if='show'>
		<el-row v-if='isExistUser'>
			<el-col :span="2">
				<img class="avatar" :src="avatar?avatar:require('../../assets/avatar.png')"  min-width="100" height="100" />
			</el-col>
			<el-col :span="4">
				<el-col :span="24" style="margin-top: 10px;">
					<el-form :inline="true">
					<el-form-item  style="margin-bottom: -5px;">
						<span style="font-size: 25px;">{{ userName }}</span>
					</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-form :inline="true">
					<el-form-item >
						<span style="font-size: 16px;color: #848181;">用户ID:</span>
						<span style="font-size: 16px;color: #848181;">{{ userId }}</span>
					</el-form-item>
					</el-form>
				</el-col>
			</el-col>
			<el-col :span="16" style="height:1px">

			</el-col>
			<el-col :span="2">
				<el-col :span="24" style="margin-top: 10px;">
					<el-form :inline="true">
					<el-form-item  style="margin-bottom: -5px;">
						<span style="font-size: 16px;color: #848181;">累计作品</span>
					</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-form :inline="true">
					<el-form-item >
						<span style="font-size: 28px;">{{ totalWorks }}个</span>
					</el-form-item>
					</el-form>
				</el-col>
			</el-col>
		</el-row>

		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="请输入作品ID" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.title" placeholder="请输入作品名称" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="selectedShelvesState" clearable placeholder="请选择上下架状态">
						<el-option v-for="item in shelvesState" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="selectedDeleteState" clearable placeholder="是否删除">
						<el-option v-for="item in deleteState" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select v-model="selcetedCheckState" clearable placeholder="请选择审核状态">
						<el-option v-for="item in checkState" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!--<el-form-item>
					<el-select v-model="selectedQrcodeState" clearable placeholder="选择群二维码状态">
						<el-option v-for="item in qrcodeState" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>-->
				<el-form-item>
					<el-button type="primary" v-on:click="getFilterList">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表 @selection-change="handleSelectionChange"-->
		<el-table ref="elTable" :data="tableData" highlight-current-row v-loading="listLoading"
							style="width: 100%;" @sort-change='sortAction' @selection-change="saveSelectedRow">
			<!-- <el-table-column type="selection" width="45"></el-table-column> -->
			<el-table-column type="selection">
			</el-table-column>
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="title" align="center" label="名称" max-width="120">
			</el-table-column>
			<el-table-column prop="createTime" align="center" label="创建时间"  :formatter="formatCreateDate" max-width="130">
			</el-table-column>
			<el-table-column prop="author" align="center" label="发布者" max-width="100">
			</el-table-column>
			<el-table-column prop="open" align="center" label="传播数" width="90" sortable='custom'>
			</el-table-column>
			<el-table-column prop="share" align="center" label="转发数" width="90" sortable='custom'>
			</el-table-column>
			<el-table-column prop="likes" align="center" label="点赞数" width="90" sortable='custom'>
			</el-table-column>
			<el-table-column align="center" label="线下扫码" width="90">
				<template slot-scope="scopeqrcode">
					<el-button type="text" @click="showDetail(scopeqrcode.row)">{{scopeqrcode.row.amount}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="remainder" align="center" label="余额" width="90">
			</el-table-column>
			<el-table-column prop="shelvesState" align="center" label="上下架" :formatter="formatShelveState" width="64">
			</el-table-column>
			<el-table-column prop="deleteState" align="center" label="删除" :formatter="formatDeleteState" width="60">
			</el-table-column>
			<el-table-column prop="endTime" label="截止时间" align="center" :formatter="formateDate" max-width="100">
			</el-table-column>
			<el-table-column label="查看" align="center" max-width="140">
				<template slot-scope="scope1">
					<el-button type="text" size="small" @click="handleForm(scope1.$index, scope1.row)">回单</el-button>
					<el-button type="text" size="small" @click="handleOpen(scope1.$index, scope1.row)">传播</el-button>
					<el-button type="text" size="small" @click="handleShare(scope1.$index, scope1.row)">转发</el-button>
					<el-button type="text" size="small" @click="handleSetting(scope1.$index, scope1.row)">详情</el-button>
					<el-button type="text" size="small" @click="handleQrSetting(scope1.$index, scope1.row)">二维码</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="auditState" align="center" label="审核" :formatter="formatCheckState" width="80">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.auditState=='PASSED'" type="success">已通过</el-tag>
					<el-tag v-else-if="scope.row.auditState=='WAITING'" type="primary">待审核</el-tag>
					<el-tag v-else-if="scope.row.auditState=='REJECTED'" type="danger">未通过</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="qrcodeTime" label="群二维码" :formatter="formateQrcodeTime" align="center" min-width="80">

			</el-table-column>
			<!--<el-table-column label="操作" min-width="80" class="button-bar" fixed='right'>
				<template slot-scope="scope">
					<el-button class="inline-btn" type="danger" size="small" @click="handleCheck(scope.$index, scope.row)">审核</el-button>
					&lt;!&ndash;<el-upload
						class="inline-btn upload-tab"
						action="https://image.witmover.com/upload"
						:on-success="uploadSuccess"
						:show-file-list=false
					>
						<el-button class="upload-btn" size="small" type="primary" @click="uploadCheck(scope.$index, scope.row)">上传</el-button>
					</el-upload>&ndash;&gt;
				</template>
			</el-table-column>-->
		</el-table>
		<div class="batch-operation universal-class">
			<el-checkbox v-model="selfCheckBox" class="checkbox-all universal-class" @change="checkBoxSelectedAll"></el-checkbox>
			<span class="checkbox-span universal-class">全选</span>
			<el-button class="check-pass universal-class" type="primary" @click="checkForProject(1)">审核通过</el-button>
			<el-button class="check-reject universal-class" type="danger" @click="checkForProject(0)">审核不通过</el-button>
			<el-button type="primary" @click="changeShelvesStatus(1)">上架</el-button>
			<el-button type="danger" @click="changeShelvesStatus(2)">下架</el-button>
			<el-button class="replace-qrcode universal-class" style="color: #409eff" @click="showReplaceDialog">更换群二维码</el-button>
			<!-- <span style="margin-left: 1%;color: red">(备注:更换二维码时图片名称应与活动Id一致,否则失败.另:不需要选中活动即可上传.)</span> -->
			<el-button type="primary" @click="changeShowOrHide(1)">展示</el-button>
			<el-button type="info" @click="changeShowOrHide(0)">隐藏</el-button>
			<el-button type="primary" @click="getSortInfo">调整小程序端优先级</el-button>
		</div>
		<div class="batch-operation universal-class">
			<!-- <el-button type="primary" @click="changeShowOrHide(1)">展示</el-button>
			<el-button type="info" @click="changeShowOrHide(0)">隐藏</el-button>
			<el-button type="primary" @click="getSortInfo">调整小程序端优先级</el-button> -->
		</div>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next, jumper, sizes" @current-change="handleCurrentChange"
				@size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage"
				:page-size="pageSize" :total="totalNumber" style="float:left;">
			</el-pagination>
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.multipleSelection.length===0"
				style="float:right;">批量下架</el-button> -->

		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="性别">
					<el-radio-group v-model="editForm.sex">
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄">
					<el-input-number v-model="editForm.age" :min="0" :max="200"></el-input-number>
				</el-form-item>
				<el-form-item label="生日">
					<el-date-picker type="date" placeholder="选择日期" v-model="editForm.birth"></el-date-picker>
				</el-form-item>
				<el-form-item label="地址">
					<el-input type="textarea" v-model="editForm.addr"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>


		<el-dialog title="作品二维码" :visible.sync="settingQrVisible" :close-on-click-modal="false" width="340px">
				<div id="qrcode" ref="qrCodeUrl" v-if='settingQrVisible' ></div>
		</el-dialog>


		<el-dialog title="详情" :visible.sync="settingVisible" :close-on-click-modal="false">
			<div class="particulars">
                <el-form :model="currentItem" label-width="100px" :rules="addFormRules" ref="chargeform">
                    <div class="particulars-left" v-if="currentItem&&currentItem.type&&currentItem.type=='IMAGE'">
<!--                        <el-form-item label="" v-if="currentItem&&currentItem.type&&currentItem.type=='IMAGE'">-->
                            <img class="work-image" :src="currentItem.resource" />
<!--                        </el-form-item>-->
                    </div>
                    <div class="particulars-right">
                        <el-form-item label="作品名称" v-if="currentItem&&currentItem.title">
                            <span>{{currentItem.title}}</span>
                        </el-form-item>
                        <el-form-item label="传播范围" v-if="currentItem&&currentItem.scope">
                            <span>{{currentItem.scope}}</span>
                        </el-form-item>
                        <el-form-item label="作品描述" v-if="currentItem&&currentItem.description">
                            <span>{{currentItem.description}}</span>
                        </el-form-item>
                        <el-form-item label="推广方式" v-if="currentItem&&currentItem.pushWay">
                            <span>{{currentItem.pushWay}}</span>
                        </el-form-item>
                        <el-form-item label="累计营销金" >
                            <span>元</span>
                        </el-form-item>
                        <el-form-item label="推广金额" v-if="currentItem&&currentItem.pushAmount">
                            <span>{{currentItem.pushAmount}}元</span>
                        </el-form-item>
                        <el-form-item label="打开红包" v-if="currentItem&&currentItem.pushOpenMin&&currentItem.pushOpenMax">
                            <span>最小：{{currentItem.pushOpenMin}}元    最大：{{currentItem.pushOpenMax}}元</span>
                        </el-form-item>
                        <el-form-item label="转发红包" v-if="currentItem&&currentItem.pushShare">
                            <span>{{currentItem.pushShare}}元</span>
                        </el-form-item>
                        <el-form-item label="幸运红包" v-if="currentItem&&currentItem.pushLuckNumber&&currentItem.pushLuckValue">
                            <span>数字：{{currentItem.pushLuckNumber}}    金额：{{currentItem.pushLuckValue}}元</span>
                        </el-form-item>
                        <el-form-item label="龙头红包" v-if="currentItem&&currentItem.pushBonusIndex&&currentItem.pushBonusValue">
                            <span>排序：{{currentItem.pushBonusIndex}}   金额：{{currentItem.pushBonusValue}}元    <input :checked="currentItem.bonusCycle" type="checkbox" /> 循环</span>
                        </el-form-item>
                        <!--<el-form-item label="大包奖励" v-if="currentItem&&currentItem.pushBonusIndex">
                            <span>第{{currentItem.pushBonusIndex}}个领取{{currentItem.pushBonusValue}}元</span>
                        </el-form-item>-->
                        <!--<el-form-item label="推广范围" v-if="currentItem&&currentItem.pushScope">
                            <span>{{currentItem.pushScope}}</span>
                        </el-form-item>-->
                        <el-form-item label="推广范围" v-if="currentItem&&currentItem.pushScope">
                            <span v-for="(item,index) in currentItem.pushScope" :key="index">{{item.fullName}}  </span>
                        </el-form-item>
                        <el-form-item label="推广结束时间">
                            <span>{{endTime}}</span>
                        </el-form-item>
                        <el-form-item label="商户手机号" v-if="currentItem&&currentItem.userPhone">
                            <span>{{currentItem.userPhone}}</span>
                        </el-form-item>
                        <el-form-item label="跳转链接" v-if="currentItem&&currentItem.outerUrl">
                            <a :href="currentItem.outerUrl">{{currentItem.outerUrl}}</a>
                        </el-form-item>
                        <el-form-item label="资源链接" v-if="currentItem&&currentItem.type&&currentItem.type=='WEB'">
                            <a :href="currentItem.resource"  target="_blank">{{currentItem.resource}}</a>
                        </el-form-item>
                        <el-form-item label="二维码">
                            <img class="qrCodeImage" v-if="currentItem&&currentItem.qrcode" :src="currentItem.qrcode" alt="">
                        </el-form-item>
                    </div>
                </el-form>
            </div>
		</el-dialog>
		<el-dialog title="充值" :visible.sync="chargeFormVisible" :close-on-click-modal="false">
			<el-form :model="chargeForm" label-width="80px" :rules="addFormRules" ref="chargeform">
				<el-form-item label="金额">
					<el-input placeholder="请输入金额" v-model="chargeForm.money" clearable>
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="chargeFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="chargeSubmit" :loading="chargeLoading">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="审核" :visible.sync="checkVisible" width="30%" >
			<span>请点击确定审核结果</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="checkVisible = false">取 消</el-button>
				<el-button @click="setCheckState(0)" :loading="loadingUnpass">不通过</el-button>
				<el-button type="primary" @click="setCheckState(1)" :loading="loadingPass">审核通过</el-button>
			</span>
		</el-dialog>
		<el-dialog title="批量替换群二维码" width="500px" :visible.sync="replaceFlockQrcodeDialog" :close-on-click-modal="false" @close="closeUploadDialog">
			<el-upload
				multiple
				ref="upload"
				action="https://zimg.yunshimenu.com/upload"
				:on-preview="handlePreview"
				:on-remove="handleRemove"
				:on-success="handleSuccess"
				:file-list="fileList"
				:auto-upload="false">
				<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
				<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
			</el-upload>
		</el-dialog>
	<!--	<el-dialog title="调整小程序端活动展示优先级" width="450px" :visible.sync="changeSortDialog" :close-on-click-modal="false" @close="closeChangeSortDialog">
			<el-form>
				<el-form-item label="活动id" style="margin-bottom: 5%">
					<el-input style="width: 50%" v-model="sortProject"></el-input>
				</el-form-item>
				<el-form-item  label="优先级" style="margin-bottom: 5%">
					<el-select v-model="sortLevel" placeholder="请选择优先级">
						<el-option
							v-for="item in level"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item align="right">
					<el-button @click="closeChangeSortDialog">取消</el-button>
					<el-button type="primary" @click="changeSortLevel">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>-->
		<!--优化level调整-->
		<el-dialog title="优先级调整" :visible.sync="changeSortDialog" :close-on-click-modal="false" @close="closeChangeSortDialog">
			<el-table
			:data="sortData"
			>
				<el-table-column prop="id" label="id" align="center"></el-table-column>
				<el-table-column prop="title" label="活动名称" align="center"></el-table-column>
				<el-table-column prop="level" label="优先级" align="center"></el-table-column>
				<el-table-column prop="level" label="操作" align="center">
					<template slot-scope="selectValues">
						<el-select v-model="sortLevel" placeholder="请调整优先级" @change="updateSort(selectValues.row)">
							<el-option
								v-for="item in level"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</template>

				</el-table-column>
			</el-table>
		</el-dialog>
	</section>
	<!-- <section>
		<router-view></router-view>
	</section> -->
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { level } from './level'
	import { getUserListPage, removeUser, batchRemoveUser, editUser, addUser } from '../../api/api';
	import QRCode from 'qrcodejs2'
	export default {
		// components: { QRCode },
		watch: {
			'$route.query.userid'(val) {
				this.getList(0)
			}
		},
		data() {
			return {
				endTime: '',
				show: true,
				cancel: null,
				cancelqr: null,
				sortMethod: null,
				loadingPass: false,
				loadingUnpass: false,
				checkVisible: false,
				settingVisible: false,
				settingQrVisible: false,
				currentId: null,
				currentItem: null,
				chargeFormVisible: false,
				selcetedCheckState: null,
				// selectedQrcodeState: null,
				selectedShelvesState: null,
				selectedDeleteState: null,
				multipleSelection: [],
				totalNumber: null,
				tableData: null,
				pageSize: 10,
				currentPage: 1,
				shelvesState: [{ label: '上架', value: 'ON_SHELVES' }, { label: '下架', value: 'OFF_SHELVES' },],
				checkState: [{ label: '待审核', value: 'WAITING' }, { label: '已通过', value: 'PASSED' }, { label: '未通过', value: 'REJECTED' }],
				// qrcodeState: [{ label: '已失效', value: '0' }, { label: '1天后失效', value: '1' }, { label: '2天后失效', value: '2' }],
				deleteState: [{ label: '已删', value: "delete" }, { label: '正常', value: 'normal' },],
				filters: {
					name: '',
					title: ''
				},
				users: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入金额', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},
				chargeLoading: false,
				chargeForm: {
					money: 0,
				},
				link: '',
				uploadUrl: '',
				projectId: '',
				selectedRows: [],
				replaceFlockQrcodeDialog: false,
				fileList: [],
				selectedRowIds: [],
				selfCheckBox: false,
				changeSortDialog: false,
				sortLevel: '',
				level: level,
				sortData: [],
				isExistUser:false,
				userId:'',
				userName:'',
				avatar:null,
			}
		},
		created() {
			if(this.$route.query.userid) {
				this.isExistUser =true;
				this.userId = this.$route.query.userid;
				this.userName = this.$route.query.userName;
				this.avatar = this.$route.query.avatar;
				this.totalWorks = this.$route.query.totalWorks;
			} else {
				this.isExistUser =false;
			}
		},
		methods: {
			async setCheckState(index) {
				let state = 'WAITING'
				if (index == 0) {
					this.loadingUnpass = true;
					state = 'REJECTED'
				} else {
					this.loadingPass = true;
					state = 'PASSED'
				}
				try {
					let result = await this.$http.post(this,`/project/${this.currentId}/audit/${state}`);
					if (index == 0) {
						this.loadingUnpass = false;
					} else {
						this.loadingPass = false;
					}
					if (result && result.code == 200) {
						this.$message({
							message: '完成',
							type: 'success'
						});
						this.getList(this.currentPage - 1);
					}
				} catch (e) {
					this.loadingPass = false;
					this.loadingUnpass = false;
				}
				this.checkVisible = false;
			},
			handleSelectionChange(val) {
				console.log('checkb0x-', val)
				this.multipleSelection = val;
			},
			formatDatas(item) {
				return {
					id: item.id,
					title: item.title,
					scope: item.districts&&item.districts.map((ele)=>{return ele.fullName}).join(','),
					createTime: item.createTime,
					description: item.description||'',
					author: item.owner&&item.owner.nickName || item.owner.username,
					remainder: !item.envelope?'免费推广':item.wallet.remainder||0,
					shelvesState: item.shelvesState,
					auditState: item.auditState,
					endTime: item.endTime,
					open: item.statistics&&item.statistics.open,
					share: item.statistics&&item.statistics.share,
					likes: item.statistics&&item.statistics.like || '0',
					resource: item.resource,
					type: item.type,
					pushWay:  item.envelope&&item.envelope.way||'红包推广',
					pushAmount: item.envelope&&item.envelope.total,
					pushShare: item.envelope&&item.envelope.share,
					pushOpenMin: item.envelope&&item.envelope.min,
					pushOpenMax: item.envelope&&item.envelope.max,
					pushLuckNumber: item.envelope&&item.envelope.luckNumber,
					pushLuckValue: item.envelope&&item.envelope.luckValue,
					pushBonusIndex: item.envelope&&item.envelope.bonusIndex,
					pushBonusValue: item.envelope&&item.envelope.bonusValue,
					pushScope: item.districts || null,
					deleteState: item.deleted,
					userPhone: item.phone,
					outerUrl: item.outerUrl,
					qrcode: item.qrCode,
					bonusCycle: item.envelope&&item.envelope.bonusCycle,
					qrcodeTime: item.qrcodeTime,
					amount: this.countMoney(item.userScanQrcodeRecords)
				};
			},
			countMoney(userScanQrcodeRecords){
				let amount = 0;
				userScanQrcodeRecords.forEach(r => {
					amount = this.addMethod(amount,r.amount);
				})
				return amount;
			},
			addMethod(arg1,arg2){
				var r1,r2,m;
				try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
				try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
				m=Math.pow(10,Math.max(r1,r2))
				return (arg1*m+arg2*m)/m
			},
			formatCreateDate(row, column) {
				if (!row.createTime) {
					return '';
				}
				return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage - 1);
			},
			getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			async getList(index) {
				this.cancel&&this.cancel();
				let body = {}
				if(this.$route.query.userid) {
					body['user'] = this.$route.query.userid;
				}
				if(this.filters.name) {
					body['id'] = this.filters.name;
				}
				if(this.filters.title) {
					body['title'] = this.filters.title;
				}
				if(this.selectedShelvesState) {
					body['shelvesState'] = this.selectedShelvesState;
				}
				if(this.selectedDeleteState) {
					body['deleted'] = this.selectedDeleteState == "delete";
				}
				if(this.selcetedCheckState) {
					body['auditState'] = this.selcetedCheckState;
				}
				/*if (this.selectedQrcodeState) {
					body['qrcodeState'] = this.selectedQrcodeState
				}*/
				let query = { pageIndex: index, pageSize: this.pageSize };
				if (this.sortMethod) {
					query['sort'] =  this.sortMethod;
				}
				/*if (this.selectedQrcodeState) {
					result = await this.$http.post(this,'/project/forQrcode',query,body,(cancel)=>{this.cancel = cancel})
				}*/
				let result = await this.$http.post(this,'/project',query ,body,(cancel)=>{this.cancel = cancel});
					if (result && result.code == 200) {
						this.tableData = result.data.data.map((item) => { return this.formatDatas(item) });
						this.totalNumber = result.data.count
						this.currentPage = result.data.page + 1
				}
			},
			formatShelveState(row, column) {
				let temp = this.shelvesState.filter((item) => {
					return item.value == row.shelvesState;
				})
				return temp[0].label;
			},
			formatCheckState(row, column) {
				let temp = this.checkState.filter((item) => {
					return item.value == row.auditState;
				})
				return temp[0].label;
			},
			formatDeleteState(row, column) {
				let temp = this.deleteState.filter((item) => {
					return (item.value=="delete") == row.deleteState;
				})
				return temp[0].label;
			},
			formateDate(row, column) {
				if (!row.endTime) {
					return '无限制';
				}
				return new Date(row.endTime).format("yyyy/MM/dd hh:mm");
			},
			formateQrcodeTime(row,column){
				// console.log(row);
				if (row.qrcodeTime == null) {
					return <span style="color: #20A0FF">--</span>
				} else {
					let qrcodeTimeMill = new Date(row.qrcodeTime).getTime()
					let endQrcodeTimeMIll = qrcodeTimeMill + (7 * 24 * 60 * 60 * 1000);
					let nowDate = new Date().getTime();
					let intervalTime = endQrcodeTimeMIll - nowDate;
					if (intervalTime >=0) {
						let day = Math.floor(intervalTime/(24 * 3600 * 1000));
						var a = intervalTime % (24 * 60 * 60 * 1000);
						let hour = Math.floor(a / (3600 * 1000));
						var b = a % (3600*1000)
						let minute = Math.floor(b / (60 * 1000))
						var c = b % (60 * 1000)
						let second = Math.round(c / 1000)
						if (day >= 2) {
							return <span style="color: #20A0FF">{day}天{hour}小时{minute}分{second}秒后失效</span>
						}else if(day == 0 && hour == 0 && minute == 0 && second == 0){
							return <span style="color: #E0461C">已失效</span>
						} else if (day == 0 && hour == 0 && minute == 0){
							return <span style="color: #E0461C">{second}秒后失效</span>
						} else if(day == 0 && hour == 0) {
							return <span style="color: #E0461C">{minute}分{second}秒后失效</span>
						} else if (day == 0) {
							return <span style="color: #E0461C">{hour}小时{minute}分{second}秒后失效</span>
						} else {
							return <span style="color: #E0461C">{day}天{hour}小时{minute}分{second}秒后失效</span>
						}
					} else {
						return <span style="color: #E0461C">已失效</span>
					}
				}
			},
			handleForm: function (index, row) {
				let url = ''
				if(this.$route.query.userid) {
					url = '/users'
				}
				this.$router.push({ path: url+'/works/form', query: { id: row.id } });
			},
			handleOpen(index, row) {
				let url = ''
				if(this.$route.query.userid) {
					url = '/users'
				}
				this.$router.push({ path: url+'/works/open', query: { id: row.id } });
			},
			handleShare(index, row) {
				let url = ''
				if(this.$route.query.userid) {
					url = '/users'
				}
				this.$router.push({ path: url+'/works/share', query: { id: row.id } });
			},
			handleCheck: function (index, row) {
				this.checkVisible = true;
				this.currentId = row.id;
			},
			async getQrcodeUrl(id) {
				this.cancelqr&&this.cancelqr();
				let result = await this.$http.get(this,`/project/${id}/share/generator`,null ,null,(cancel)=>{this.cancelqr = cancel});
				return result.data;
			},
			qrcode (qrurl) {
                let that = this;
                let qrcode = new QRCode('qrcode', {
                    width: 300,
                    height: 300,        // 高度
                    text:  process.env.CONFIG.frontUrl + 'share/' + qrurl,   // 二维码内容
                    // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                    // background: '#f0f',   // 背景色
                    // foreground: '#ff0'    // 前景色
                })
  		      },
			async handleSetting(index, row) {
					this.settingVisible = true;
				//this.currentId = row.id;
				this.currentItem = this.tableData.filter((item)=>{
					return row.id == item.id;
				})[0]
				var endTime = this.currentItem.endTime
				if (endTime == null) {
					console.log('为null，无限制')
					this.endTime = '无限制';
				} else if (endTime == '无限制') {
					console.log('就是无限制，无限制')
					this.endTime = '无限制';
				} else {
					console.log('日期转换')
					this.endTime = row.endTime
					var date = new Date(endTime);
					let year = date.getFullYear(),
							month = date.getMonth() + 1,
							day = date.getDate() + '',
							hours = date.getHours(),
							minutes = date.getMinutes()

					this.endTime = year + '/' +
							month + '/' + day + ' ' + hours + ':' + minutes
				}
				console.log(this.endTime)
				console.log('this.currentItem--', this.currentItem)
			},
			async handleQrSetting(index, row) {
				let qrurl = await this.getQrcodeUrl(row.id)
				if(qrurl) {
					this.settingQrVisible = true;
					this.$nextTick ( () => {
						this.qrcode(qrurl);
					})
				}
			},
			sortAction (column, prop, order ) {
				this.sortMethod = 'statistics.' + column.prop + ':' + (column.order == 'ascending'? 'ASC' : 'DESC');
				this.getFilterList();
			},
			//显示新增界面
			handleAdd: function () {
				this.$router.push('/table/table1')
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							editUser(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								//	this.getUsers();
							});
						});
					}
				});
			},
			chargeSubmit() {
				this.$refs.chargeform.validate(async (valid) => {
					if (valid) {
						this.chargeLoading = true;
						let para = {
							amount: this.chargeForm.money,
						}
						let result = await this.$http.post(this,`/project/${this.currentId}/recharge`, para);
						if (result.code == 200) {
							this.chargeLoading = false;
							this.$message({
								message: '充值成功',
								type: 'success'
							});
							this.chargeForm.money = 0;
							this.chargeFormVisible = false;
							this.getList(this.currentPage - 1);
						} else {
							this.$message({
								message: '充值失败',
								type: 'fail'
							});
						}
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.addForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							addUser(para).then((res) => {
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								//this.getUsers();
							});
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						//this.getUsers();
					});
				}).catch(() => {

				});
			},
			uploadSuccess(response){
				let res = response.split('"')[1]
				this.uploadUrl = 'https://image.witmover.com' + res
				this.$http.post(this,'/project/uploadOnePicture',{url: this.uploadUrl,projectId: this.projectId})
				this.uploadUrl = ''
			},
			uploadCheck(index,row){
				this.projectId = row.id
			},
			saveSelectedRow(val){
				let ids = []
				val.forEach(item => {
					ids.push(item.id)
				})
				this.selectedRowIds = ids
				this.selectedRows =val
				console.log(this.selectedRows);
				console.log(this.selectedRowIds);
			},
			async checkForProject(index){
				if (this.selectedRows.length == 0) {
					this.$message({
						message: '请选择要审核的活动！',
						type: "warning"
					})
					return
				}
				this.listLoading = true
				let falseResult = []
				for(let i=0;i<this.selectedRows.length;i++){
					let state = 'WAITING'
					if (index == 0) {
						this.loadingUnpass = true;
						state = 'REJECTED'
					} else {
						this.loadingPass = true;
						state = 'PASSED'
					}
					try {
						let result = await this.$http.post(this,`/project/${this.selectedRows[i].id}/audit/${state}`);
						if (!result || result.code != 200) {
							if(result && result.code == 666) {
								this.$notify({
									title: '提示',
									message: 'id为' + this.selectedRows[i].id + '的活动审核失败,原因是' + '"' + result.message + '"!',
									type: 'warning',
									duration: 5000
								})
							}
							falseResult.push(this.selectedRows[i].id)
						}
					} catch (e) {
						console.log(e);
					}

				}
				if (falseResult.length > 0 ) {
					this.$message({
						message: 'id ' + falseResult + ' 审核失败！',
						type: "error"
					})
				} else {
					if (this.selectedRows.length > 0) {
						this.$message({
							message: '审核成功！',
							type: "success"
						})
					} else {
						this.$message({
							message: '请选择要审核的活动！',
							type: "warning"
						})
					}
				}
				this.listLoading = false
				this.selfCheckBox = false
				this.getList(this.currentPage - 1);
				// this.$router.go(0);
			},
			showReplaceDialog(){
				this.replaceFlockQrcodeDialog = true
			},
			handleRemove(file, fileList) {
				// console.log(file, fileList);
			},
			submitUpload() {
				this.$refs.upload.submit();
			},
			handlePreview(file) {
				console.log(file);
			},
			handleSuccess(response,file){
				let res = response.split('"')[1]
				let projectId = file.name.split('.')[0]
				var numReg = /^[0-9]*$/
				var numRe = new RegExp(numReg)
				//  || this.selectedRowIds.indexOf(parseInt(projectId)) == -1
				if (!numRe.test(projectId)) {
					this.$message({
						type: "error",
						message: '未找到二维码 ' + file.name + ' 对应的活动，请检查后请重新上传！',
						duration: 10000,
						showClose: true,
					})
					return false
				} else {
					this.$message({
						type: "success",
						message: '二维码 ' + file.name + ' 替换成功！',
						duration: 10000,
						showClose: true,
					})
				}
				this.uploadUrl = 'https://zimg.yunshimenu.com' + res
				console.log(this.uploadUrl);
				this.$http.post(this,'/project/uploadOnePicture',{url: this.uploadUrl,projectId: projectId})
				this.uploadUrl = ''
			},
			checkBoxSelectedAll(){
				this.$refs.elTable.toggleAllSelection()
			},
			closeUploadDialog(){
				this.getList(this.currentPage - 1)
			},
			async showDetail(row){
				let qrurl = await this.getQrcodeUrl(row.id)
				let sn = null;
				if(qrurl) {
					sn = qrurl;
				}
				let body = {
					id: row.id,
					title: row.title,
					description: row.description,
					sn: sn,
					resource: row.resource
				}
				this.$router.push({ path: '/works/qrcodes',query: body });
			},
			changeShelvesStatus(val){
				let ids = this.selectedRowIds
				this.$http.post(this,'/project/changeShelvesStatus',{shelvesStatus: val}, ids).then(res => {
					this.$message({
						type: res.code==200? 'success' : 'error',
						message: res.code == 200? '修改成功！': res.message
					})
					this.getList(0)
				})
			},
			changeShowOrHide(param){
				let projectId = null
				let that = this
				if (this.selectedRowIds.length == 0){
					this.$message({
						type: "error",
						message: '请选择活动！'
					})
					return
				} else {
					projectId = this.selectedRowIds[0]
				}
				this.$http.post(this,'/miniProgram/changeShowStatus',{projectId: projectId,isShow: param}).then(res => {
					if (res && res.code == 200){
						this.$message({
							type: "success",
							message: '状态修改成功！'
						})
						that.getList(0)
					} else {
						this.$message({
							type: "error",
							message: '状态修改失败！'
						})
					}
				})
			},
			closeChangeSortDialog(){
				this.changeSortDialog = false
				this.sortProject = null
				this.sortLevel = 1
			},
			getSortInfo(){
				this.$http.post(this,'/miniProgramSort/getSortList').then(res => {
					if (res && res.data) {
						this.sortData = res.data
					}
				})
				this.changeSortDialog = true
			},
			updateSort(row){
				this.$http.post(this,'/miniProgramSort/changeLevel',{projectId: row.id, level: this.sortLevel}).then(res => {
					if (res && res.code == 200){
						this.$message({
							type: "success",
							message: '修改成功！'
						})
						this.getSortInfo()
					} else {
						this.$message({
							type: "error",
							message: '修改失败！'
						})
					}
				})
				this.sortLevel = ''
			},
		},
		mounted() {
			this.getList(0);
		}
	}

</script>

<style scoped>
	.el-button+.el-button {
		margin-left: 4px;
	}

	.el-button--small,
	.el-button--small.is-round {
		padding: 8px 10px;
	}

    .el-form-item {
        margin-bottom: 0px;
    }

	.el-button--text {
		padding-left: 0;
		padding-right: 0;
	}
	.work-image {
		width: 190px;
		height: auto;
	}
	#qrcode {
		text-align: center;
	}

    .particulars-left {
        margin: 0 4%;
        display: inline-block;
    }

    .particulars-right {
        display: inline-block;
		width: 70%;
    }

	.qrCodeImage {
		width: 100px;
	}

	.inline-btn {
		display:  inline-block;
	}

	.upload-tab {
		margin-left: 2%;
	}

	.universal-class {
		margin-left: 1%;
		margin-top: 5px;
	}
</style>
